import { useTu } from "@src/appV2/i18n/useTu";
import { Box, type SxProps, type Theme } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";

interface OrDividerProps {
  /** Extra styles merged into the divider row (e.g. `marginTop`). */
  sx?: SxProps<Theme>;
}

/**
 * Horizontal "— or —" divider placed between a primary action and an
 * alternative one. Shared so every login sub-screen renders it identically.
 */
export function OrDivider({ sx }: OrDividerProps = {}): React.ReactElement {
  const { tu } = useTu("login");

  return (
    <Box
      sx={[
        { display: "flex", alignItems: "center", alignSelf: "stretch", gap: 5 },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Box sx={{ flex: 1, height: "1px", backgroundColor: "border.base" }} />
      <Text variant="body2" sx={{ color: "base.inactive" }}>
        {tu("or")}
      </Text>
      <Box sx={{ flex: 1, height: "1px", backgroundColor: "border.base" }} />
    </Box>
  );
}
